//function change city
//todo: Перенести на ajax класс
function changeCity(sxgeo_id, extend_code) {
    $.ajax({
        type: 'POST',
        url: '/ajax/change-city',
        data: {'sxgeo_id': sxgeo_id, 'extend_code': extend_code},
        success: function(url) {
            window.location.href = url + window.location.pathname;
        }
    });
}